export const debateFormatEnum = {
  "British Parliamentary": "British Parliamentary",
  "Public forum": "Public forum",
  "Lincoln–Douglas": "Lincoln–Douglas",
  WSDC: "WSDC",
  "Fun Debate": "Fun Debate",
};

export const JudgeDebateReducerEnum = {
  ADD_JUDGE_DEBATE_DETAILS: "ADD_JUDGE_DEBATE_DETAILS",
  UPDATE_START_TIME_COUNT_DOWN: "UPDATE_START_TIME_COUNT_DOWN",
  UPDATE_DEBATE_STATE: "UPDATE_DEBATE_STATE",
  SET_JUDGE_DECISION_DATA: "SET_JUDGE_DECISION_DATA",
  CLOSE_MIC: "CLOSE_MIC",
  OPEN_MIC: "OPEN_MIC",
  SET_ROUND_REMAINING_TIME: "SET_ROUND_REMAINING_TIME",
  SET_ACTIVE_SPEAKER: "ADD_ACTIVE_SPEAKER",
  ADD_ROOM_COACHES: "ADD_ROOM_COACHES",
  ADD_ROOM_AUDIENCES: "ADD_ROOM_AUDIENCES",
  ADD_ROOM_MEMBERS: "ADD_ROOM_MEMBERS",
  SET_ROOM_MEMBERS: "SET_ROOM_MEMBERS",
  SET_ROOM_COACHES: "SET_ROOM_COACHES",
  SET_ROOM_AUDIENCES: "SET_ROOM_AUDIENCES",
  SET_LOADING_START: "SET_LOADING_START",
  SET_LOADING_END: "SET_LOADING_END",
  SET_UID: "SET_UID",
  SET_LOCAL_AUDIO_TRACKS: "SET_LOCAL_AUDIO_TRACKS",
  ADD_REMOTE_AUDIO_TRACKS: "ADD_REMOTE_AUDIO_TRACKS",
  REMOVE_REMOTE_AUDIO_TRACK: "REMOVE_REMOTE_AUDIO_TRACK",
  REMOVE_ROOM_MEMBER: "REMOVE_ROOM_MEMBER",
  REMOVE_ROOM_COACH: "REMOVE_ROOM_COACH",
  REMOVE_ROOM_AUDIENCE: "REMOVE_ROOM_AUDIENCE",
  SET_IS_DECIDING_WINNER: "SET_IS_DECIDING_WINNER",
  UPDATE_COACH_DECISION_STATE: "UPDATE_COACH_DECISION_STATE",
  ADD_LIVE_CHAT: "ADD_LIVE_CHAT",
  TOGGLE_CAN_MOVE_TO_NEXT_MOTION: "TOGGLE_CAN_MOVE_TO_NEXT_MOTION",
};

export const TournamentReducerEnum = {};
